import { CustomHttpClient, IRequestOptions } from './../../providers/CustomHttpClient';
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { UploadCarga } from '../../model/upload-carga';

@Injectable({
  providedIn: 'root'
})
export class UploadCargaService {

  constructor(private http: CustomHttpClient) { }

  uploadFile(formData: any, is_ressarcimento: number, email: string) {
    return this.http.Post("api/upload/UploadFile/" + is_ressarcimento + "/" + email, formData);
  }

  logCritica(isCarga: number) {
    //window.open("api/upload/LogCritica/" + isCarga);
    return this.http.Get("api/upload/LogCritica/" + isCarga);
  }
  
  ListaCarga(isRessarcimento: number) {
    return this.http.Get("api/upload/ListaCarga/" + isRessarcimento);
  }
}
